import produce from "immer";
import { MarketCampaignActions } from ".";
import { IStoreState } from "../initialStoreState";

import {
  FETCH_CAMPAIGN_RULE_TEMPLATES_FAILED,
  FETCH_CAMPAIGN_RULE_TEMPLATES_PROGRESS,
  FETCH_CAMPAIGN_RULE_TEMPLATES_SUCCESS,
} from "./marketCampaignActions";
import { LoadState } from "../../constants/enums";
import { initialMarketCampaignState } from "./marketCampaign.types";

export const marketCampaignReducer = (
  state: IStoreState["marketCampaign"] = initialMarketCampaignState,
  action: MarketCampaignActions
) => {
  switch (action.type) {
    case FETCH_CAMPAIGN_RULE_TEMPLATES_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.marketCampaignRuleTemplate.loading = LoadState.InProgress;
        draftState.marketCampaignRuleTemplate.list = [];
      });
      return newState;
    }
    case FETCH_CAMPAIGN_RULE_TEMPLATES_SUCCESS: {
      const { list } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.marketCampaignRuleTemplate.loading = LoadState.Loaded;
        draftState.marketCampaignRuleTemplate.list = list;
      });
      return newState;
    }
    case FETCH_CAMPAIGN_RULE_TEMPLATES_FAILED: {
      const newState = produce(state, (draftState) => {
        draftState.marketCampaignRuleTemplate.loading = LoadState.Failed;
        draftState.marketCampaignRuleTemplate.list = [];
      });
      return newState;
    }
    default: {
      return state;
    }
  }
};
